import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProjectsComponent } from './projects.component';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { MatButtonModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatSelectModule, MatTableModule, MatTabsModule } from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { AddOnsModule } from './project-create/tabs/add-ons/add-ons.module';
import { AddOnsListModule } from './project-create/tabs/add-ons-list/add-ons-list.module';

const routes = [
  { path: '', redirectTo: 'projects', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'projects', component: ProjectsComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    NgxChartsModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    RoundProgressModule,
    AddOnsModule,
    AddOnsListModule
  ],
  declarations: [
  ],

})
export class ProjectsModule { }
